import React from 'react'
import { Loader } from '@components/icons'
import s from './Indicator.module.scss'
import cn from 'classnames'

export const LoadingIndicator: React.FC<{
    isHubSpotLoader?: boolean
}> = ({ isHubSpotLoader = false }) => {
    if (isHubSpotLoader) {
        return (
            <div id="hubspot-container" className={s['hubspot-container']}>
                <div className={s['loading-hubspot']}>
                    <div className={s['loading-message']}>
                        <Loader />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={s['loading-container']}>
            <div className={cn(s['loading-message'], 'loading-messag')}>
                <Loader />
            </div>
        </div>
    )
}
